

export const vpModeLive = "vp-mode-live";
export const vpModeVOD = "vp-mode-vod"
export const maxLiveReplayTime = 1800;